import {EBzAlertTypes} from './eAlertTypes.enum';

export class BzAlertMessage implements IBzAlertMessage {

  public type: string;
  public message: string;
  public timeout: number;

  constructor() {
    this.type = EBzAlertTypes[EBzAlertTypes.Warning];
    this.message = '';
    this.timeout = 5000;
  }

}
